import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { IonItem, IonLabel, IonList } from "@ionic/react";

interface props {
  quiz: any;
}

const ScoringRounds: React.FC<props> = ({ quiz }) => {
  const history = useHistory();

  const selectRound = (round: number) => {
    // routerLink={`/scoring/${round.id}`};
    // console.log("score: ", round);
    history.push(`/scoring/${round}`);
  };

  return (
    <>
      <div className="container">
        <h2>Select Round</h2>
        <IonList lines="full">
          {quiz.quizConfig.rounds.map((round: any, i: number) => (
            <IonItem
              key={i}
              button
              onClick={() => selectRound(i)}
              detail={true}
            >
              <IonLabel>
                R{i + 1}: {round.roundName}
              </IonLabel>
            </IonItem>
          ))}
          {quiz.quizConfig.format.isCrossword && (
            <IonItem
              button
              onClick={() => selectRound(quiz.quizConfig.format.rounds)}
              detail={true}
            >
              <IonLabel>CW: Crossword</IonLabel>
            </IonItem>
          )}
        </IonList>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  quiz: state.quiz,
});

export default connect(mapStateToProps, {})(ScoringRounds);
